<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>speKwo - Training Section</title>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
</head>
<body>
    <div class="training-container">
        <div class="training-header">
            <h1>speKwo Training Section</h1>
            <p>Learn how to navigate our repair quote request process with this step-by-step guide</p>
        </div>
        
        <div class="training-content">
            <div class="instruction-container">
                <h2><i class="fas fa-graduation-cap"></i> Repair Quote Process Instructions</h2>
                
                <div class="instruction-points">
                    <div class="point">
                        <div class="point-icon">
                            <i class="fas fa-home"></i>
                        </div>
                        <span class="point-number">1</span>
                        <h3>Home Page</h3>
                        <p>From the speKwo home page, locate and click the "Request Repair Quote" button to proceed to the product selection page.</p>
                    </div>
                    
                    <div class="point">
                        <div class="point-icon">
                            <i class="fas fa-box-open"></i>
                        </div>
                        <span class="point-number">2</span>
                        <h3>Product Selection</h3>
                        <p>Choose from our three product options: "The Full speKwo", "ITEMIZED SOLUTION ESTIMATE", or "Pre-List Quote".</p>
                    </div>
                    
                    <div class="point">
                        <div class="point-icon">
                            <i class="fas fa-map-marked-alt"></i>
                        </div>
                        <span class="point-number">3</span>
                        <h3>Address Information</h3>
                        <p>After selecting a product, you'll be directed to the address page where you can enter the customer's address details.</p>
                    </div>
                </div>
                
                <div class="video-section">
                    <h3><i class="fas fa-video"></i> Address Entry Demonstration</h3>
                    <div class="video-wrapper">
                        <video width="576" height="300" controls>
                            <source src="assets/img/logos/Address.mp4" type="video/mp4" />
                            <source src="movie.ogg" type="video/ogg" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    
                    <div class="video-description">
                        <p>This video demonstrates how to properly navigate to the address entry page after selecting your preferred product. Watch how to correctly input the customer's address information to ensure accurate service delivery.</p>
                    </div>
                </div>
                
                <div class="step-divider">
                    <span>Next Step</span>
                </div>
                
                <div class="instruction-points">
                    <div class="point">
                        <div class="point-icon">
                            <i class="fas fa-user-tag"></i>
                        </div>
                        <span class="point-number">4</span>
                        <h3>Role Selection</h3>
                        <p>After entering the address, you need to select your role from the available options such as buyer, seller, Home Inspector, or Broker Etc..</p>
                        
                        <div class="role-options">
                            <div class="role-option">
                                <i class="fas fa-user"></i>
                                <p>Buyer</p>
                            </div>
                            <div class="role-option">
                                <i class="fas fa-home"></i>
                                <p>Seller</p>
                            </div>
                            <div class="role-option">
                                <i class="fas fa-handshake"></i>
                                <p>Home Inspector</p>
                            </div>
                            <div class="role-option">
                                <i class="fas fa-chart-line"></i>
                                <p>Broker</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="video-section">
                    <h3><i class="fas fa-video"></i> Role Selection Demonstration</h3>
                    <div class="video-wrapper">
                        <video width="576" height="300" controls>
                            <source src="assets/img/logos/RoleSelecting.mp4" type="video/mp4" />
                            <source src="movie.ogg" type="video/ogg" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    
                    <div class="video-description">
                        <p>This video demonstrates how to select your role after entering the address information. Choosing the correct role helps us tailor the repair quote process to your specific needs and situation.</p>
                    </div>
                </div>
                
                <div class="step-divider">
                    <span>Next Step</span>
                </div>
                
                <div class="instruction-points">
                    <div class="point">
                        <div class="point-icon">
                            <i class="fas fa-address-card"></i>
                        </div>
                        <span class="point-number">5</span>
                        <h3>Contact & Client Details</h3>
                        <p>Provide your contact information and your client's details to ensure we can communicate with you after creating your order.</p>
                        
                        <div class="step-content">
                            <div class="detail-items">
                                <div class="detail-item">
                                    <i class="fas fa-check-circle"></i>
                                    <span>Enter your contact details including email and phone number for order confirmation and updates</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fas fa-check-circle"></i>
                                    <span>Provide your client's details including their email, phone number, and role (buyer or seller)</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fas fa-check-circle"></i>
                                    <span>Select your local market from the available options</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fas fa-check-circle"></i>
                                    <span>Choose the appropriate firm</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fas fa-check-circle"></i>
                                    <span>Enter the affiliate name if applicable</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fas fa-check-circle"></i>
                                    <span>Select who should receive email updates by checking the appropriate boxes</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fas fa-check-circle"></i>
                                    <span>Agree to the terms and conditions and proceed to the next step</span>
                                </div>
                            </div>
                            
                            <div class="info-tip">
                                <i class="fas fa-info-circle"></i>
                                All information provided is secure and will only be used for order processing and communication.
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="video-section">
                    <h3><i class="fas fa-video"></i> Contact Details Demonstration</h3>
                    <div class="video-wrapper">
                        <video width="576" height="300" controls>
                            <source src="assets/img/logos/CustomerClientDetails.mp4" type="video/mp4" />
                            <source src="movie.ogg" type="video/ogg" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    
                    <div class="video-description">
                        <p>This video demonstrates how to enter your contact details and client information. It shows how to select the local market, firm, and affiliate name, set communication preferences, and agree to terms to proceed to the next step.</p>
                    </div>
                </div>
            </div>
            
            <div class="note-box">
                <h4><i class="fas fa-lightbulb"></i> About speKwo</h4>
                <p>speKwo has been in development for over 20 years. Our leadership team brings extensive experience from buying, fixing, and selling houses; completing remodels for realtors and investors; and evaluating over 2,000 inspection quotes. This deep industry knowledge ensures we provide the most accurate and reliable repair quotes in the industry.</p>
            </div>
        </div>
        
        <div class="footer">
            <p>© 2023 speKwo - All rights reserved</p>
        </div>
    </div>
</body>
</html>